import { BaseInputProps } from "@talladega/types";
import classNames from "classnames";

type Props = Pick<
  BaseInputProps,
  "leftIcon" | "rightIcon" | "border" | "placeholderSize" | "status" | "cursor"
>;

export function getInputFocusStyle() {
  return "focus:border-brand kijiji:focus:border-info autocan:focus:border-primary-bold focus:ring-1 focus:ring-offset-0 focus:ring-secondary kijiji:focus:ring-info autocan:focus:ring-primary-bold focus:shadow-none focus:text-primary kijiji:focus:text-gray-600 autocan:focus:text-gray-900 focus:border focus:shadow-primary-500/8";
}

export function getInputStyles({
  leftIcon,
  rightIcon,
  border = "normal",
  placeholderSize = "medium",
  status = "default",
  cursor = "auto",
}: Props): string {
  const statusColor: Record<string, string> = {
    default: "border-primary kijiji:border-other-light-100",
    error: "border-error focus:border-error focus:shadow-error/8",
  };
  return classNames(
    "body-3 form-input font-normal bg-white rounded-lg w-full focus:outline-none placeholder-gray-500",
    getInputFocusStyle(),
    "disabled:bg-background-light-300 disabled:border-other-light-100",
    {
      "pl-8": leftIcon,
    },
    {
      "pr-8": rightIcon,
    },
    {
      border: border === "normal",
    },
    {
      "border-2 focus:border-2": border === "thick",
    },
    {
      "placeholder:text-sm": placeholderSize === "small",
    },
    statusColor[status] || statusColor.default,
    {
      "hover:cursor-pointer": cursor === "pointer",
    }
  );
}
